import { useThemeSwitch } from "sj-ui-toolkit/src/theme";

import S from "./EmailNotificationFooter.module.scss";
import emailFooterLight from "@/assets/images/email/footer.png";
import emailFooterDark from "@/assets/images/email/footer-dark.png";

export const EmailNotificationFooter = () => {
  const { appliedTheme } = useThemeSwitch();
  const emailFooter = appliedTheme === "atlas-dark" ? emailFooterDark : emailFooterLight;

  return (
    <div className={S.root}>
      <div className={S.divider}></div>
      <div className={S.socialCollection}>
        <div className={S.socialItem}>
          <a href="https://www.securityjourney.com/">
            <img src={emailFooter} alt="Security Journey" />
          </a>
        </div>
      </div>
      <div className={S.address}>3402 Apex Peakway, Apex, NC 27502</div>
      <div className={S.divider}></div>
      <br />
    </div>
  );
};
